export default {"src":"/_next/static/media/footerLogo.bd19321f.svg","height":65,"width":64,"blurWidth":0,"blurHeight":0};